<template>

	<!-- 필터 -->
	<div class="filter">
		<div class="inner grid-col-2">

			<!-- 첨 : grid-col-2의 숫자를 col-box의 갯수만큼 2,3,4로 변경 -->
			<div class="col-box" v-for="(code, index) in codeList">
				<label>{{ code.codeName }}</label>
				<select :id="'sel-code-' + (index + 1)" v-if="code.children.length > 0" @change="selectCode($event, index + 1)">
					<option value="">분류를 선택해 주세요.</option>
					<option v-for="(item, i) in code.children" :value="item.code">{{ item.codeName }}</option>
				</select>
			</div>

			<!--<div class="col-box">
				<label>02 Category</label>
				<select>
					<option>분류를 선택해 주세요.</option>
					<option>분류</option>
					<option>분류</option>
					<option>분류</option>
					<option>분류</option>
					<option>분류</option>
				</select>
			</div>-->

		</div>
	</div>
	<!-- 검색 -->

</template>

<script>
export default {
	name: "codeTreeSelector",
	props: {
		baseCode: String,   // 기본코드 지정
		oldCode: String,    // 기존코드 표출시 지정
	},
	data() {

		return {
			codeVO: {},
			codeList: [],
		}
	},
	created() {

	},
	mounted() {

		this.init();
	},
	methods: {

		async init () {

			this.codeVO = await this.getCodeOne( this.baseCode )
			this.codeList.push( this.codeVO )

			if ( !this.stringUtils.isEmpty( this.oldCode ) ) {
				this.setOldCode( this.oldCode );
			}

		},

		async selectCode (e, _index) {

			// console.log(e.target.value)

			// 코드 인덱스까지 잘라서 새로 코드목록 정의
			const tempArray = this.codeList.slice(0, _index)
			this.codeList = tempArray;

			// 선택된 값이 있을때만 하위 코드 추가
			if ( e.target.value !== '' ) {
				const tempCode = await this.getCodeOne(e.target.value)
				if ( tempCode.children.length > 0 ) {
					this.codeList.push( tempCode )
				}
				this.$emit("selectCode", e.target.value)

			} else {
				if ( _index > 0 ) {
					_index--;
				}

				// this.$emit("selectCode", temp)
				// return

				let temp = $('#sel-code-' + _index).val()
				temp = (_index <= 0) ? this.baseCode : temp;
				this.$emit("selectCode", temp)
			}

		},



		async setOldCode ( _oldCode ) {

			// 기존코드를 2자리로 배열 선언
			const childCodes = _oldCode.replace( this.baseCode, "" )
			let subArr = []
			for (let i = 0; i < childCodes.length;) {

				subArr.push( childCodes.substr(i, 2) );
				i = i + 2;
			}
			// console.log( subArr )

			// 기존 선택된 CodeVO 배열로 정의 + DOM 표출
			var temp = this.baseCode
			for (const value of subArr) {
				temp += value;
				var tempCode = await this.getCodeOne( temp );
				if ( tempCode.children.length > 0 ) {
					this.codeList.push( tempCode )
				}
			}
			// console.log( this.codeList )

			// DOM의 기존 코드 지정
			var temp = this.baseCode
			const doms = document.querySelectorAll("select")
			for (let i = 0; i < doms.length; i++) {
				temp += subArr[i];
				doms[i].value = temp;
			}

		}


	}
}
</script>

<style scoped>

</style>